export { FuneralPrepareFuneralCostContainer as default } from "containers/FuneralPrepareContainer";
